/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import { Redirect, Route } from 'react-router-dom';

import { isAuthenticatedVar } from 'Apollo/config';
import { isAuthenticated } from '../views/Auth/AuthHelper';

const ProtectedRoute = ({ component: Component, ...restOfProps }) => {
    const loggedIn = isAuthenticated();
    isAuthenticatedVar(loggedIn);
    return (
        <Route
            {...restOfProps}
            render={props => (loggedIn
                ? <Component {...props} /> : <Redirect to="/login" />)}
        />
    );
};

export default ProtectedRoute;
